import { createFileRoute } from '@tanstack/react-router';

import { NotificationsPage } from '@/features/settings';

export const Route = createFileRoute('/_authenticated/_withWorkspace/settings/notifications')({
  component: NotificationsPage,
});
